import React from "react";
import Button from "@material-ui/core/Button";

import { buttonStyles } from "../../courseStyles";

// eslint-disable-next-line react/prop-types
export default function CreateButton({ onCreateClick, title }) {
  const classes = buttonStyles();
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onCreateClick && onCreateClick()}
        className={classes.button}
      >
        {title}
      </Button>
    </div>
  );
}
